module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"missing_required_fields":"因未满足条件，无法获得奖励。"}}')
  delete Component.options._Ctor
}
